// extracted by mini-css-extract-plugin
module.exports = {"main":"NotFoundPage_main__2b0Vo","imageFrame":"NotFoundPage_imageFrame__2W7MS","copyright":"NotFoundPage_copyright__25qB7"};